import { Table } from 'dexie'
import { IClientDataDoc } from './clientData.service'
import { DB_NAME_PREFIX, IndexDbService } from './indexDb.service'
import { IStoragePcr } from './pcrDocs.service'
import { IPcrBackupMetadata } from '../features/pcrBackup/store/pcrBackup.types'

export class NowIndexDbService extends IndexDbService {
  pcrDocs!: Table<IStoragePcr, string>
  clientData!: Table<IClientDataDoc, string>
  pcrBackupMetadata!: Table<IPcrBackupMetadata, string>

  constructor(database: string) {
    super(DB_NAME_PREFIX + database)

    this.db.version(4).stores({
      pcrBackupMetadata: 'pcrId',
    })

    // Although there are no structural changes, a version bump is required here since this is when we updated to Dexie-encrypted.
    // Going from non-encrypted to encrypted is considered a schema change.
    this.db.version(3).stores({
      pcrDocs: 'pcrId,createdBy',
    })

    this.db.version(2).stores({
      clientData: 'id,createDateTime',
    })

    this.db.version(1).stores({
      pcrDocs: 'pcrId,createdBy',
    })

    // Instantiate all tables here
    this.pcrDocs = this.db.table('pcrDocs')
    this.clientData = this.db.table('clientData')
    this.pcrBackupMetadata = this.db.table('pcrBackupMetadata')

    this.db.open()
  }
}
